import { lang } from '@umu/ukit-lang';
/**
 * @description 举报相关的服务
 */

import { components, services } from 'common';
const { CustomDialog, AlertDialog } = components;
const { Toast } = services;
import { reportIssue } from '@umu/umu-api';
import { IInputData, IOption } from '@umu/umu-api/src/services/report/reportIssue';
import { ERROR_CODE, REPORT_TYPE, REPORT_CATEGORY_TYPE, IUserInfo } from '@umu/umu-types';

import { ReportReason } from './components/@reportReason/reportReason';
import { REPORT_REASON_FOR_CONTENT, REPORT_REASON_FOR_USER } from './reportUtil';

function AlertInfo() {
    AlertDialog({
        className: 'alert ugc-report-result-info-alert',
        title: '',
        content: lang('谢谢，我们已经收到您的举报。如果我们发现此内容违反了我们的社区准则，就会将其移除。'),
    });
}

export interface IParams {
    targetId: string;
    category: REPORT_CATEGORY_TYPE;
    reportUserInfo: IUserInfo; // 举报者
    reportedUserInfo: IUserInfo; // 被举报者
    reportedUrl?: string; // 被举报内容URL
}

// tslint:disable-next-line:max-line-length
export function report(reportType: REPORT_TYPE, params: IParams) {
    openReportDialog(reportType, params);
}

function getOptions(params: IParams) {
    const defaultHref = ''; // $window.location.href;
    params.reportUserInfo = Object.assign({}, params.reportUserInfo);
    params.reportedUserInfo = Object.assign({}, params.reportedUserInfo);

    const data: IOption[] = [
        {
            key: 'from_user_page',
            value: params.reportUserInfo.person_home_url || defaultHref,
        },
        {
            key: 'violation_user_page',
            value: params.reportedUserInfo.person_home_url || defaultHref,
        },
    ];

    if (params.category !== REPORT_CATEGORY_TYPE.USER) {
        data.push({
            key: 'violation_url',
            value: params.reportedUrl || defaultHref,
        });
    }
    return data;
}

export function openReportDialog(reportType: REPORT_TYPE, params: IParams) {
    const onReportCallback = (type: string) => {
        const data: IInputData = {
            target_id: `${params.targetId}`,
            category: params.category,
            problem: parseInt(type, 10),
            args: getOptions(params),
        };
        reportIssue({
            data: JSON.stringify(data),
        }).then((result) => {
            if (result.error_code === 0) {
                AlertInfo();
                return;
            }
            switch (result.error_code) {
                case ERROR_CODE.REPORT_OVER_LIMIT:
                    Toast.show({ message: lang('你的举报过于频繁') });
                    break;
                case ERROR_CODE.REPORT_REPEAT:
                    Toast.show({ message: lang('你已经举报过该内容') });
                    break;
                default:
                    Toast.show({ message: lang('提交失败，请重试') });
                    break;
            }
        });
    };

    CustomDialog({
        className: 'basic-report-dialog',
        canClose: true,
        width: '3.25rem',
        childProps: {
            dataSource: reportType === REPORT_TYPE.CONTENT_BLOCK ? REPORT_REASON_FOR_CONTENT : REPORT_REASON_FOR_USER,
            onReportCallback,
        },
        contentComponent: ReportReason,
    });
}
